import { Box, Divider, Skeleton } from '@frontend-workspace/react-shared-lib';

export function ContractDetailsSkeleton() {
  return (<>
    <Box>
      <div className="d-flex flex-wrap">
        <Skeleton className="me-3" animation="wave" width={100} height={50} />
        <Skeleton className="me-3" animation="wave" width={100} height={50} />
        <Skeleton className="me-3" animation="wave" width={100} height={50} />
      </div>
      <Divider className="mb-1" />
    </Box>
  </>);
}

export default ContractDetailsSkeleton;
